const camelcaseKeys = require('camelcase-keys');

const camelize = val => {
    if (typeof val !== 'object') {
        return val;
    }

    const regexpToIgnoreDots = /\./;

    return camelcaseKeys(val, { deep: true, exclude: [regexpToIgnoreDots] });
};

export default val => camelize(val);
